<!-- 本科学员点击预约-弹窗 -->
<template>
  <div class='modal-mask'
       v-if='isShow'
       @click="maskCloseBtn">
    <div class='modal-wrap'>
      <div class='modal-container'
           :style='{width: defaultWidth}'
           @click="closeContainerBtn">
        <h4 class='title'>Appointment information</h4>
        <p class='small-title'>{{appointInfo.module && new Map(packageModuleMap).get(appointInfo.module)}}</p>
        <div class='appoint-detail'>
          <div class='appoint-item'><span class='appoint-title'>Mentee proposed time：</span>（{{ appointInfo.menteeZone | zoneEnFilter }}）</div>
          <div v-if='appointInfo.createTrack && appointInfo.createTrack.content && appointInfo.createTrack.content.length > 0'>
            <div class='appoint-item'
                 v-for='(time, index) in appointInfo.createTrack.content'
                 :key='index'>{{time.minTimeStr}} - {{time.maxTimeStr}}</div>
          </div>
          <div class='appoint-item'><span>Discussion topic：</span>{{appointInfo.title}}</div>
          <div class='appoint-item'><span>Expected duration：</span>{{appointInfo.predictTime}}mins</div>
          <div class='appoint-item'><span>Other information：</span>{{appointInfo.otherMsg}}</div>
        </div>
        <div class='appoint-sub'>
          <div class='radio-wrap'>
            <h5 class='appoint-sub-title'>Time zone：</h5>
            <Select v-model='formValidate.mentorZone'
                    @on-change='changeTimeZone'
                    clearable>
              <Option v-for='item in zoneEnMap'
                      :key='item.value'
                      :value='item.value'>{{item.title}}</Option>
            </Select>
            <p class='error'>{{mentorZoneError}}</p>
          </div>
        </div>
        <div class='appoint-sub'>
          <div class='radio-wrap'>
            <h5 class='appoint-sub-title'>Are the suggested time okay for you?</h5>
            <div class='radio-group'
                 v-for='item in appointOk'
                 :key='item.id'
                 @click="checkedOk(item)">
              <img :src='unRadio'
                   v-if='!item.checked' />
              <img :src='radio'
                   v-if='item.checked' />
              <span class='text'>{{item.name}}</span>
            </div>
            <p class='error'>{{appointOkError}}</p>
          </div>
          <div class='radio-wrap'
               v-if='formValidate.okTime === "ok"'>
            <h5 class='appoint-sub-title'>Please select one slot：</h5>
            <div v-if='showTime'>
              <div class='radio-group'
                   v-for='item in checkTime'
                   :key='item.id'
                   @click="checkOneTime(item)">
                <img :src='unRadio'
                     v-if='!item.checked' />
                <img :src='radio'
                     v-if='item.checked' />
                <span class='text'>{{item.minTimeStr}} - {{item.maxTimeStr}}</span>
              </div>
            </div>
            <div v-else>
              <div class='radio-group'
                   v-for='item in checkTime'
                   :key='item.id'>
                <img :src='unRadio'
                     v-if='!item.checked' />
                <img :src='radio'
                     v-if='item.checked' />
                <span class='text'>{{item.minTimeStr}} - {{item.maxTimeStr}}</span>
              </div>
            </div>
            <p class='error'>{{checkTimeError}}</p>
          </div>
          <div class='radio-wrap'
               v-if='formValidate.okTime === "no"'>
            <div class='forms-kind'>
              <h4 class='appoint-sub-title'>Your suggested time</h4>
              <p class='warning'>Please select the time in accordance with your time zone. To better schedule your time, we suggest you make appointments at least two days later.</p>
              <Row class='item-list'>
                <Col span='24'>
                <div class='form-item'>
                  <p class='time-title'>First choice</p>
                  <div>
                    <DatePicker type="date"
                                v-model="dateOne"
                                :editable='false'
                                :options="optionsTime"
                                placeholder="Select date"
                                style="display:inline-block"
                                @on-change='dateCheckOneDate'></DatePicker>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <TimePicker type="time"
                                format="HH:mm"
                                v-model="dateOneStartTime"
                                :editable='false'
                                :disabled='!dateOne'
                                placeholder="Select time"
                                style="display:inline-block"
                                @on-change='dateCheckOneStartTime'></TimePicker>
                    <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                    <TimePicker type="time"
                                format="HH:mm"
                                v-model="dateOneEndTime"
                                :editable='false'
                                :disabled='!dateOneStartTime'
                                :disabled-hours='dateOneEndTimeOption'
                                placeholder="Select time"
                                style="display:inline-block"
                                @on-change='dateCheckOneEndTime'></TimePicker>
                  </div>
                  <p class='error'>{{dateOneError}}</p>
                </div>
                </Col>
                <Col span='24'>
                <div class='form-item'>
                  <p class='time-title'>Second choice</p>
                  <div>
                    <DatePicker type="date"
                                v-model="dateTwo"
                                :editable='false'
                                :options="optionsTime"
                                placeholder="Select date"
                                style="display:inline-block"
                                @on-change='dateCheckTwoDate'></DatePicker>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <TimePicker type="time"
                                format="HH:mm"
                                v-model="dateTwoStartTime"
                                :editable='false'
                                :disabled='!dateTwo'
                                placeholder="Select time"
                                style="display:inline-block"
                                @on-change='dateCheckTwoStartTime'></TimePicker>
                    <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                    <TimePicker type="time"
                                format="HH:mm"
                                v-model="dateTwoEndTime"
                                :editable='false'
                                :disabled='!dateTwoStartTime'
                                :disabled-hours='dateTwoEndTimeOption'
                                placeholder="Select time"
                                style="display:inline-block"
                                @on-change='dateCheckTwoEndTime'></TimePicker>
                  </div>
                  <p class='error'>{{dateTwoError}}</p>
                </div>
                </Col>
                <Col span='24'>
                <div class='form-item'>
                  <p class='time-title'>Third choice</p>
                  <div>
                    <DatePicker type="date"
                                v-model="dateThree"
                                :editable='false'
                                :options="optionsTime"
                                placeholder="Select date"
                                style="display:inline-block"
                                @on-change='dateCheckThreeDate'></DatePicker>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <TimePicker type="time"
                                format="HH:mm"
                                v-model="dateThreeStartTime"
                                :editable='false'
                                :disabled='!dateThree'
                                placeholder="Select time"
                                style="display:inline-block"
                                @on-change='dateCheckThreeStartTime'></TimePicker>
                    <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                    <TimePicker type="time"
                                format="HH:mm"
                                v-model="dateThreeEndTime"
                                :editable='false'
                                :disabled='!dateThreeStartTime'
                                :disabled-hours='dateThreeEndTimeOption'
                                placeholder="Select time"
                                style="display:inline-block"
                                @on-change='dateCheckThreeEndTime'></TimePicker>
                  </div>
                  <p class='error'>{{dateThreeError}}</p>
                </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div class='oper'>
          <Button @click="confirmCancel"
                  class='cancel'>Cancel</Button>
          <Button href='javascript:void(0)'
                  @click="confirmOk"
                  :loading='hasConfirm'
                  class='ok'>Confirm</Button>
        </div>
        <div class='modal-close'
             @click="maskCloseBtn">
          <img :src='modalClose' />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import radio from '@/assets/undergraduate/images/btn_radio.png'
import unRadio from '@/assets/undergraduate/images/btn_unradio.png'
import modalClose from '@/assets/undergraduate/images/modal_close.png'
import appointmentService from '@/api/undergraduate/appointment'
import { zoneEnMap, packageModuleMap } from '../constants'

export default {
  name: '',
  filters: {
    zoneEnFilter (value) {
      let find = zoneEnMap.find(o => o.value === value)
      if (find) {
        return find.title
      }
      return ''
    }
  },
  props: {
    uncomfirmId: {
      type: Number,
      default: -1
    },
    hasConfirm: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    },
    defaultWidth: {
      type: String,
      default: '500px'
    },
    maskClose: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      // 单选选中图片
      radio,
      // 单选未选中图片
      unRadio,
      // 关闭图片
      modalClose,
      // 时区映射
      zoneEnMap,
      // 套餐模块映射
      packageModuleMap,
      // 预约详情
      appointInfo: {},
      appointOk: [
        {
          id: 'ok',
          name: 'Yes',
          checked: false
        },
        {
          id: 'no',
          name: 'No, need to schedule other time',
          checked: false
        }
      ],
      // 预约判断
      appointOkError: '',
      checkTime: [],
      // 预约其他时间
      checkTimeError: '',
      // 选择1, 2, 3日期时间及其限制
      optionsTime: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      dateOne: '',
      dateOneStartTime: '',
      dateOneEndTime: '',
      dateOneEndTimeOption: [],
      dateTwo: '',
      dateTwoStartTime: '',
      dateTwoEndTime: '',
      dateTwoEndTimeOption: [],
      dateThree: '',
      dateThreeStartTime: '',
      dateThreeEndTime: '',
      dateThreeEndTimeOption: [],
      formValidate: {
        okTime: '',
        mentorZone: '',
        checkOne: '',
        dateOne: ['', ''],
        dateTwo: ['', ''],
        dateThree: ['', '']
      },
      mentorZoneError: '',
      dateOneError: '',
      dateTwoError: '',
      dateThreeError: '',
      originTime: [],
      checkTimeId: undefined,
      // 选择时区时，控制时间选择，避免网速慢导致的问题
      showTime: true
    }
  },
  computed: {},
  mounted () {
    this.getAppointDetail()
  },
  methods: {
    // 获取预约详情
    getAppointDetail () {
      if (this.uncomfirmId !== -1) {
        appointmentService.appointDetail({ id: this.uncomfirmId }).then(res => {
          this.appointInfo = res.data.model
          if (this.appointInfo.createTrack && this.appointInfo.createTrack.content && this.appointInfo.createTrack.content.length > 0) {
            this.appointInfo.createTrack.content.map((item, index) => {
              this.checkTime.push({ ...item, checked: false, id: index + 1 })
              this.originTime.push({ ...item, checked: false, id: index + 1 })
            })
          }
        }).catch(res => {
          this.$ugd_message(res.message, 'error')
        })
      }
    },
    // 遮罩层点击关闭
    maskCloseBtn () {
      this.$emit('closeModal')
      this.resetStatus()
    },
    // 阻止冒泡
    closeContainerBtn (e) {
      e.stopPropagation()
      return false
    },
    // 确认弹窗的确认操作
    confirmOk () {
      if (this.isValid()) {
        let data = { ...this.formValidate, content: [], ugdAppointmentTimeId: this.appointInfo.id }
        if (data.okTime === 'ok') {
          let check = this.originTime.filter(o => o.id === this.checkTimeId)[0]
          data.resultTimeStr = `${check.minTimeStr} - ${check.maxTimeStr}`
          data.resultTime = data.resultTimeStr.split(' - ')[0]
          data.content = null
        }
        if (data.okTime === 'no') {
          data.content = [{
            maxTime: this.formValidate.dateOne[1],
            maxTimeStr: this.formValidate.dateOne[1],
            minTime: this.formValidate.dateOne[0],
            minTimeStr: this.formValidate.dateOne[0]
          },
          {
            maxTime: this.formValidate.dateTwo[1],
            maxTimeStr: this.formValidate.dateTwo[1],
            minTime: this.formValidate.dateTwo[0],
            minTimeStr: this.formValidate.dateTwo[0]
          },
          {
            maxTime: this.formValidate.dateThree[1],
            maxTimeStr: this.formValidate.dateThree[1],
            minTime: this.formValidate.dateThree[0],
            minTimeStr: this.formValidate.dateThree[0]
          }]
        }
        this.$emit('appointModalOk', data)
      }
    },
    // 确认弹窗的取消操作
    confirmCancel () {
      this.maskCloseBtn()
    },
    // 以上时间可以吗-change切换
    checkedOk (item) {
      this.formValidate.okTime = item.id
      this.appointOkError = ''
      this.checkTimeError = ''
      this.dateOneError = ''
      this.dateTwoError = ''
      this.dateThreeError = ''
      if (this.formValidate.okTime !== 'no') {
        this.dateOne = ''
        this.dateOneStartTime = ''
        this.dateOneEndTime = ''
        this.dateOneEndTimeOption = []
        this.dateTwo = ''
        this.dateTwoStartTime = ''
        this.dateTwoEndTime = ''
        this.dateTwoEndTimeOption = []
        this.dateThree = ''
        this.dateThreeStartTime = ''
        this.dateThreeEndTime = ''
        this.dateThreeEndTimeOption = []
        this.formValidate.dateOne = ['', '']
        this.formValidate.dateTwo = ['', '']
        this.formValidate.dateThree = ['', '']
      }
      this.appointOk.map(items => {
        if (item.id === items.id) {
          items.checked = true
        } else {
          items.checked = false
        }
      })
    },
    // 选择时区onChange事件
    changeTimeZone (val) {
      let data = {
        content: [...this.checkTime],
        mentorZone: val
      }
      this.showTime = false
      appointmentService.timeTransition(data).then(res => {
        this.showTime = true
        this.checkTime = []
        if (res.data.model && res.data.model.length > 0) {
          for (let i = 0; i < res.data.model.length; i++) {
            let item = { ...res.data.model[i], checked: false, id: i + 1 }
            this.$set(this.checkTime, i, item)
          }
        }
      }).catch(error => {
        this.showTime = true
        this.$ugd_message(error.message, 'error')
        this.formValidate.mentorZone = ''
      })
      this.formValidate.mentorZone = val
      if (val !== '' && val !== undefined) {
        this.mentorZoneError = ''
      } else {
        this.mentorZoneError = 'Please select Time zone'
      }
    },
    // 重新选一个时间-change切换
    checkOneTime (item) {
      this.formValidate.checkOne = `${item.minTimeStr} - ${item.maxTimeStr}`
      this.checkTimeId = item.id
      this.checkTimeError = ''
      this.checkTime.map(items => {
        if (item.id === items.id) {
          items.checked = true
        } else {
          items.checked = false
        }
      })
    },
    // 第一选择日期
    dateCheckOneDate (val) {
      this.dateOne = val
      this.dateOneStartTime = ''
      this.formValidate.dateOne = ['', '']
      if (this.dateOne !== '') {
        this.dateOneError = ''
      } else {
        this.dateOneError = 'Please select datetime'
      }
    },
    dateCheckOneStartTime (val) {
      this.dateOneStartTime = val
      this.dateOneEndTime = ''
      this.formValidate.dateOne[1] = ''
      if (this.dateOneStartTime !== '') {
        this.formValidate.dateOne[0] = `${this.dateOne} ${val}`
        this.dateOneError = ''
      } else {
        this.formValidate.dateOne[0] = ''
        this.dateOneError = 'Please select datetime'
      }
    },
    dateCheckOneEndTime (val) {
      this.dateOneEndTime = val
      if (this.dateOneEndTime !== '') {
        this.formValidate.dateOne[1] = `${this.dateOne} ${val}`
        this.dateOneError = ''
      } else {
        this.formValidate.dateOne[1] = ''
        this.dateOneError = 'Please select datetime'
      }
    },
    // 第二选择日期
    dateCheckTwoDate (val) {
      this.dateTwo = val
      this.dateTwoStartTime = ''
      this.formValidate.dateTwo = ['', '']
      if (this.dateTwo !== '') {
        this.dateTwoError = ''
      } else {
        this.dateTwoError = 'Please select datetime'
      }
    },
    dateCheckTwoStartTime (val) {
      this.dateTwoStartTime = val
      this.dateTwoEndTime = ''
      this.formValidate.dateTwo[1] = ''
      if (this.dateTwoStartTime !== '') {
        this.formValidate.dateTwo[0] = `${this.dateTwo} ${val}`
        this.dateTwoError = ''
      } else {
        this.formValidate.dateTwo[0] = ''
        this.dateTwoError = 'Please select datetime'
      }
    },
    dateCheckTwoEndTime (val) {
      this.dateTwoEndTime = val
      if (this.dateTwoEndTime !== '') {
        this.formValidate.dateTwo[1] = `${this.dateTwo} ${val}`
        this.dateTwoError = ''
      } else {
        this.formValidate.dateTwo[1] = ''
        this.dateTwoError = 'Please select datetime'
      }
    },
    // 第三选择日期
    dateCheckThreeDate (val) {
      this.dateThree = val
      this.dateThreeStartTime = ''
      this.formValidate.dateThree = ['', '']
      if (this.dateThree !== '') {
        this.dateThreeError = ''
      } else {
        this.dateThreeError = 'Please select datetime'
      }
    },
    dateCheckThreeStartTime (val) {
      this.dateThreeStartTime = val
      this.dateThreeEndTime = ''
      this.formValidate.dateThree[1] = ''
      if (this.dateThreeStartTime !== '') {
        this.formValidate.dateThree[0] = `${this.dateThree} ${val}`
        this.dateThreeError = ''
      } else {
        this.formValidate.dateThree[0] = ''
        this.dateThreeError = 'Please select datetime'
      }
    },
    dateCheckThreeEndTime (val) {
      this.dateThreeEndTime = val
      if (this.dateThreeEndTime !== '') {
        this.formValidate.dateThree[1] = `${this.dateThree} ${val}`
        this.dateThreeError = ''
      } else {
        this.formValidate.dateThree[1] = ''
        this.dateThreeError = 'Please select datetime'
      }
    },
    // 重置状态
    resetStatus () {
      this.appointOk = [
        {
          id: 'ok',
          name: 'Yes',
          checked: false
        },
        {
          id: 'no',
          name: 'No, need to schedule other time',
          checked: false
        }
      ]
      // 预约判断
      this.appointOkError = ''
      this.checkTime = []
      // 预约其他时间
      this.checkTimeError = ''
      this.formValidate = {
        okTime: '',
        mentorZone: '',
        checkOne: '',
        dateOne: ['', ''],
        dateTwo: ['', ''],
        dateThree: ['', '']
      }
      this.mentorZoneError = ''
      this.dateOneError = ''
      this.dateTwoError = ''
      this.dateThreeError = ''
      this.dateOne = ''
      this.dateOneStartTime = ''
      this.dateOneEndTime = ''
      this.dateOneEndTimeOption = []
      this.dateTwo = ''
      this.dateTwoStartTime = ''
      this.dateTwoEndTime = ''
      this.dateTwoEndTimeOption = []
      this.dateThree = ''
      this.dateThreeStartTime = ''
      this.dateThreeEndTime = ''
      this.dateThreeEndTimeOption = []
    },
    // 提交前校验
    isValid () {
      let isOk = true
      if (this.formValidate.okTime === '') {
        this.appointOkError = 'Please select one suggested time okay for you'
        isOk = false
      }
      if (this.formValidate.mentorZone === '') {
        this.mentorZoneError = 'Please select Time zone'
        isOk = false
      }
      if (this.formValidate.checkOne === '' && this.formValidate.okTime === 'ok') {
        this.checkTimeError = 'Please select one slot'
        isOk = false
      }
      if ((this.formValidate.dateOne[0] === '' || this.formValidate.dateOne[1] === '') && this.formValidate.okTime === 'no') {
        this.dateOneError = 'Please select datetime'
        isOk = false
      }
      if ((this.formValidate.dateTwo[0] === '' || this.formValidate.dateTwo[1] === '') && this.formValidate.okTime === 'no') {
        this.dateTwoError = 'Please select datetime'
        isOk = false
      }
      if ((this.formValidate.dateThree[0] === '' || this.formValidate.dateThree[1] === '') && this.formValidate.okTime === 'no') {
        this.dateThreeError = 'Please select datetime'
        isOk = false
      }
      return isOk
    }
  }
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(230, 234, 241, 0.7);
  z-index: 9999;
  .modal-wrap {
    max-height: 100vh;
    overflow-y: scroll;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 #e6eaf1;
    .modal-container {
      background: #fff;
      padding: 60px;
      position: relative;
      .title {
        text-align: center;
        font-size: 20px;
        color: #6a7786;
        letter-spacing: 0;
      }
      .small-title {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: #323c47;
        letter-spacing: 0;
        padding: 20px;
      }
      .appoint-detail {
        text-align: left;
        font-size: 16px;
        color: #667483;
        .appoint-item {
          line-height: 28px;
          span {
            color: #353f49;
            font-weight: bold;
          }
        }
      }
      .appoint-sub {
        text-align: left;
        font-size: 16px;
        .appoint-sub-title {
          padding: 20px 0 10px 10px;
          font-size: 16px;
          color: #353f49;
          font-weight: bold;
          letter-spacing: 0;
          line-height: 22px;
          position: relative;
          &::after {
            content: "*";
            display: block;
            color: #ff5f00;
            position: absolute;
            top: 20px;
            left: 0;
          }
        }
        .warning {
          font-size: 14px;
          line-height: 28px;
          color: #ff6020;
          letter-spacing: 0;
        }
        .item-list {
          .time-title {
            font-size: 14px;
            color: #667483;
            padding: 20px 0 10px;
          }
        }
        .radio-group {
          img {
            display: inline-block;
            width: 16px;
            height: 16px;
          }
          .text {
            margin-left: 20px;
          }
        }
      }
      .oper {
        text-align: center;
        button {
          display: inline-block;
          font-size: 14px;
          margin: 20px;
          width: 116px;
          height: 32px;
          border-radius: 8px;
          text-align: center;
        }
        .cancel {
          border: 1px solid #b1bcc8;
          color: #b1bcc8;
        }
        .ok {
          background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
          color: #fff;
        }
      }
      .modal-close {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 36px;
        height: 36px;
        padding: 10px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .error {
    color: #f00;
    font-size: 14px;
  }
}
</style>
